import { DefaultWebhookForm, WebhookFormData } from "@/Features";
import { Button, Loader, styled } from "@monolith-forensics/monolith-ui";
import { Link, useParams } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";
import {
  useGetWebhook,
  useUpdateWebhook,
} from "@/Features/Webhooks/webhooks.query";
import LoggingAPI from "@/api/logging";
import { usePermissions } from "@/hooks/usePermissions";
import { useSnackbar } from "notistack";

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  max-width: 700px;
  gap: 20px;
`;

const PageTitle = styled.h2``;

export const EditWebhookPage = () => {
  const { currentUser } = usePermissions();
  const { uuid } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const { mutate: updateWebhook } = useUpdateWebhook();

  const { data, isLoading } = useGetWebhook({ uuid });

  const webhook = data?.data?.[0];

  const handleSubmit = (data: WebhookFormData) => {
    updateWebhook({
      uuid: data?.uuid,
      name: data?.name,
      description: data?.description,
      url: data?.url,
      events: data?.events,
    });

    LoggingAPI.createLog({
      case_id: undefined,
      user_id: currentUser.user_id,
      message: `Updated webhook: ${defaultFormData.name}`,
      event: "webhook:update",
      object_type: "webhook",
      object_uuid: uuid,
    });

    enqueueSnackbar("Webhook updated successfully", {
      variant: "success",
    });
  };

  const defaultFormData = {
    name: webhook?.name || "",
    description: webhook?.description || "",
    url: webhook?.url || "",
    events: webhook?.events || [],
    secret: webhook?.secret || "",
    uuid: webhook?.uuid || "",
  };

  return (
    <StyledContent>
      <Link to={"/settings/api"}>
        <Button
          size="xs"
          variant="text"
          leftSection={<ArrowLeftIcon size={16} />}
          style={{ color: "grey" }}
        >
          API Settings
        </Button>
      </Link>
      <PageTitle>Edit Webhook</PageTitle>
      {isLoading ? (
        <Loader />
      ) : (
        <DefaultWebhookForm
          onSubmit={handleSubmit}
          defaultFormData={defaultFormData}
        />
      )}
    </StyledContent>
  );
};
